import { render } from "./AdmEditFornecedorView.vue?vue&type=template&id=7007705f"
import script from "./AdmEditFornecedorView.vue?vue&type=script&lang=js"
export * from "./AdmEditFornecedorView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__